import { uiGameManager } from '../../EntryShared.ts';
import { StorageWrapper } from '../../StorageWrapper.ts';
export class UIGameAnimationBase {
    get isAnimationInProgress() {
        return this._isAnimationInProgress;
    }
    start() {
        this._isAnimationInProgress = true;
        uiGameManager.eventController.registerUIGameAnimation(this);
        if (this.areAnimationsDisabled()) this.stop();
        return this;
    }
    stop(ignoreCallback = false) {
        var _this_onStopCallback, _this;
        if (!this._isAnimationInProgress) return;
        this._isAnimationInProgress = false;
        uiGameManager.eventController.unregisterUIGameAnimation(this);
        if (!ignoreCallback) (_this_onStopCallback = (_this = this).onStopCallback) === null || _this_onStopCallback === void 0 ? void 0 : _this_onStopCallback.call(_this);
        this.resetToDefaultState();
    }
    setOnStopCallback(onStopCallback) {
        this.onStopCallback = onStopCallback;
    }
    areAnimationsDisabled() {
        if (this.forceEnableAnimation) return false;
        if (StorageWrapper.getAnimation() == true) return false;
        return true;
    }
    static composeAnimations(animations, delayBetweenAnimations) {
        for(let i = 0; i < animations.length - 1; i++){
            const currentAnimation = animations[i];
            const nextAnimation = animations[i + 1];
            currentAnimation.setOnStopCallback(()=>{
                setTimeout(()=>{
                    nextAnimation.start();
                }, delayBetweenAnimations);
            });
        }
        return animations[0];
    }
    constructor(){
        this._isAnimationInProgress = false;
    }
}
